export default {
  app: {
    notFound: {
      title: 'Strona nie znaleziona.',
      subtitle: 'Wygląda na to, że się zgubiłeś.',
      text: 'Nie martw się, pomożemy Ci nawigować stąd',
    },
  },
};
